var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.classes,style:({'background-color': _vm.backgroundColor, 'border-color': _vm.borderColor, 'color': _vm.color}),attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }